export default __webpack_public_path__ + "4f930c1b8391334297cca9a6ae0679d4.svg";